<template>
  <div class="epidmic">
    <div class="epidmic-banner">
      <img src="@/assets/index/epidmedic/dp-top-banner.png" />
    </div>
    <div class="epidemic-proposal" @click="goLetter()">
      <img src="@/assets/index/epidmedic/dp-yq-icon.png" alt />
      <p>《倡议书》</p>
      <p>至全区各级党组织和扩大党员干部的一封信</p>
      <p>查阅</p>
      <img
        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAUCAYAAABbLMdoAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1NzNENEVGQjQ3RkExMUVBOUY3QUFFMEJCQ0FFQzUxMiIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1NzNENEVGQzQ3RkExMUVBOUY3QUFFMEJCQ0FFQzUxMiI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU3M0Q0RUY5NDdGQTExRUE5RjdBQUUwQkJDQUVDNTEyIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU3M0Q0RUZBNDdGQTExRUE5RjdBQUUwQkJDQUVDNTEyIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+5F+OZwAAAPFJREFUeNpinDlz5gQGBgZLIK5IS0vbz4AHMAFxPhCbAfHkWbNmiRNSfAPK1gbiI0ANKvgUuwHxLSgfpHALUIMUNsWM////ZwBKKgLZW4FYEyp+HYi9gX64j6EYBKCm7QNidagcyDZnoIYnGIqhGkDO2A51DghcBmIvmAYUxVANoBDZj+SkOyB/gZyEoRiqQRVI7QBiJajQFZAfsCqGamAFUqeA2AAqdJGJgXjwixRnuJHvQaKDjuhIITa6maWkpGSB9C4g1oCK3YSa+BhbqgMpVEPyjA9Q4TNsYceCZOJVqIkv8aXnCdCYysWnEAQAAgwALCt8+NCMPAkAAAAASUVORK5CYII="
      />
    </div>
    <div class="epidemic-choose">
      <span
        v-for="(data,i) in choose"
        :class="i==choosed ?'choosed':''"
        @click="chooseF(i)"
        :key="i"
      >{{data}}</span>
    </div>

    <div class="epidemic-dynamic" v-show="choosed==0">
      <div class="epidemic-dynamic-nationwide">
        <div class="epidemic-title">
          <span>全国疫情动态</span>
          <span>截止到{{nowTime}}</span>
          <span @click="gobaidu()">查看数据详情</span>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAUCAYAAABbLMdoAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo3M0FBRDA3ODQ3RkIxMUVBOTlGQ0Q3NkExQkNGRkRBQSIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo3M0FBRDA3OTQ3RkIxMUVBOTlGQ0Q3NkExQkNGRkRBQSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjczQUFEMDc2NDdGQjExRUE5OUZDRDc2QTFCQ0ZGREFBIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjczQUFEMDc3NDdGQjExRUE5OUZDRDc2QTFCQ0ZGREFBIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+4UrayAAAARxJREFUeNqUk8FKQlEQho8XcVFQ4kKod9AINZdJiyikIHyT2rYJW9rK10gEoQKDctEmSER9Bg1caEi4UOH2DcyNwnO4deBjNt8/59wZbiRVXpwbYxa9y2jVhBwPbqCSvl7u/EVuQwyaBPbC5AK0IAkPBHadMm/9pJ7BKyTgzhWQzobAB+UAnmELnghkrLIGZpQSvEEcGgRSVlkDE8q+dIZteCGQs8qWGzagHtwQ8X3fOSqke8oxiHTlmX+cqKOjfGAT5L0D6c7z+p5FXKPcqjiVHYi40lk7PkIWhnAUiL+moR1rKsqSTn+K3zLips5WtvguFbG9skHEdZkl5GEMRcSOaxotvXoEJy4xkEWcwyFiN2zOF/pbdcOW8iXAADPCY93IYD2gAAAAAElFTkSuQmCC"
            alt
          />
        </div>
        <div class="epidemic-dynamic-nationwide-people">
          <div class="nationwide-people-template" v-for="(data,i) in epideDate" :key="i">
            <p v-text="data.people"></p>
            <p v-text="data.title"></p>
            <p>
              <span>较昨日</span>
              <span v-text="data.incr" v-show="data.incr!='-undefined' "></span>
            </p>
          </div>
        </div>
      </div>
      <div class="epidemic-local-sichuan">
        <div class="epidemic-title">
          <span>本地疫情</span>
        </div>
        <div class="sichuan-data">
          <div class="sichuan-data-template">
            <p>四川省</p>
            <p>
              确诊
              <span style="color: rgb(227, 57, 12);" v-text="localDate.confirmed"></span>例
            </p>
            <p>
              死亡
              <span style="color: rgb(89, 89, 89);" v-text="localDate.deadCount"></span>例
            </p>
            <p>
              治愈
              <span style="color: rgb(12, 150, 104);" v-text="localDate.curedCount"></span>例
            </p>
          </div>
        </div>
      </div>
      <div class="epidemic-realtime-dynamic">
        <div class="epidemic-title">
          <span>实时动态</span>
        </div>
        <div
          class="realtime-dynamic-template"
          @click="goDetail(data)"
          v-for="(data,i) in dynamicDate"
          :key="i"
        >
          <p>
            {{data.createtime | times}}
            <span>{{data.post}}</span>
          </p>
          <p>{{data.headline}}</p>
          <img :src="findImg(data.memo)" v-show="findImg(data.memo)" />
        </div>
      </div>
      <div class="look-more" @click="lookMore('dynamic')" v-show="tempDynamic.length>0">
        <span>更多信息</span>
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1RUM2QzlDMjQ3RkExMUVBOTNCMDgzQUEyNjc3NDFDRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1RUM2QzlDMzQ3RkExMUVBOTNCMDgzQUEyNjc3NDFDRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVFQzZDOUMwNDdGQTExRUE5M0IwODNBQTI2Nzc0MUNEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjVFQzZDOUMxNDdGQTExRUE5M0IwODNBQTI2Nzc0MUNEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YSZVdwAAAMRJREFUeNqMkEEOgkAMRWcaPIILrwdEMOrClQeBACPBPReTlScwMv5vGjMhE0OTT0v7H22wzrmHMWbnvb9DmVkR1toBSlFOgseozRRqV8CtwoxRsPUyz7PTYQlVf+CKHtZkyPICg6KEajWdkLoI3+mM/poMa1GIzTP0BUWkQK8PNvfsKdzRS4aRhCswOCBtMMygHPVTP5DrfFDPL5LlnTDQ/Aa0h65B/wYVS7/EfhaNUBO8NzE4ekEAHZG2uOKldTQ+AgwAa8ptyi8hUCQAAAAASUVORK5CYII="
        />
      </div>
    </div>

    <div class="epidemic-prevention" v-show="choosed==1">
      <div class="text-box">
        <div class="epidemic-title">
          <span>图文信息</span>
        </div>
        <div
          class="text-template"
          @click="goDetail(data)"
          v-for="(data,i) in preventionDate"
          :key="i"
        >
          <img :src="findImg(data.memo)" v-show="findImg(data.memo)" />
          <p v-text="data.headline"></p>
          <p style="display: flex; color: rgb(153, 153, 153); font-size: 0.24rem;">
            <span style="width: 50%;">{{data.post}}</span>
            <span style="margin-left: auto;">{{data.createtime | times}}</span>
          </p>
        </div>
        <div class="look-more" @click="lookMore('prevention')" v-show="tempPrevention.length>0">
          <span>更多信息</span>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1RUM2QzlDMjQ3RkExMUVBOTNCMDgzQUEyNjc3NDFDRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1RUM2QzlDMzQ3RkExMUVBOTNCMDgzQUEyNjc3NDFDRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVFQzZDOUMwNDdGQTExRUE5M0IwODNBQTI2Nzc0MUNEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjVFQzZDOUMxNDdGQTExRUE5M0IwODNBQTI2Nzc0MUNEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YSZVdwAAAMRJREFUeNqMkEEOgkAMRWcaPIILrwdEMOrClQeBACPBPReTlScwMv5vGjMhE0OTT0v7H22wzrmHMWbnvb9DmVkR1toBSlFOgseozRRqV8CtwoxRsPUyz7PTYQlVf+CKHtZkyPICg6KEajWdkLoI3+mM/poMa1GIzTP0BUWkQK8PNvfsKdzRS4aRhCswOCBtMMygHPVTP5DrfFDPL5LlnTDQ/Aa0h65B/wYVS7/EfhaNUBO8NzE4ekEAHZG2uOKldTQ+AgwAa8ptyi8hUCQAAAAASUVORK5CYII="
          />
        </div>
      </div>
      <div class="epidemic-title">
        <span>视频信息</span>
      </div>
      <div class="video-box">
        <div
          class="video-template"
          @click="goDetail(data)"
          v-for="(data,i) in preventionVideoDate"
          :key="i"
        >
          <img :src="data.photo | img" />
          <p>{{data.headline}}</p>
          <p style="display: flex; color: rgb(153, 153, 153);">
            <span></span>
            <span style="margin-left: auto;">{{data.createtime | times}}</span>
          </p>
        </div>
      </div>
      <div
        class="look-more"
        @click="lookMore('preventionVideo')"
        v-show="tempPreventionVideo.length>0"
      >
        <span>更多信息</span>
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1RUM2QzlDMjQ3RkExMUVBOTNCMDgzQUEyNjc3NDFDRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1RUM2QzlDMzQ3RkExMUVBOTNCMDgzQUEyNjc3NDFDRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVFQzZDOUMwNDdGQTExRUE5M0IwODNBQTI2Nzc0MUNEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjVFQzZDOUMxNDdGQTExRUE5M0IwODNBQTI2Nzc0MUNEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YSZVdwAAAMRJREFUeNqMkEEOgkAMRWcaPIILrwdEMOrClQeBACPBPReTlScwMv5vGjMhE0OTT0v7H22wzrmHMWbnvb9DmVkR1toBSlFOgseozRRqV8CtwoxRsPUyz7PTYQlVf+CKHtZkyPICg6KEajWdkLoI3+mM/poMa1GIzTP0BUWkQK8PNvfsKdzRS4aRhCswOCBtMMygHPVTP5DrfFDPL5LlnTDQ/Aa0h65B/wYVS7/EfhaNUBO8NzE4ekEAHZG2uOKldTQ+AgwAa8ptyi8hUCQAAAAASUVORK5CYII="
        />
      </div>
    </div>

    <div class="epidemic-battle" v-show="choosed==2">
      <div class="text-box">
        <div class="epidemic-title">
          <span>图文信息</span>
        </div>
        <div class="text-template" @click="goDetail(data)" v-for="(data,i) in battleDate" :key="i">
          <img :src="findImg(data.memo)" v-show="findImg(data.memo)" />
          <p>{{data.headline}}</p>
          <p style="display: flex; color: rgb(153, 153, 153); font-size: 0.24rem;">
            <span style="width: 50%;">东坡区融媒体中心</span>
            <span style="margin-left: auto;">{{data.createtime | times}}</span>
          </p>
        </div>
        <div class="look-more" @click="lookMore('battle')" v-show="tempBattle.length>0">
          <span>更多信息</span>
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1RUM2QzlDMjQ3RkExMUVBOTNCMDgzQUEyNjc3NDFDRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1RUM2QzlDMzQ3RkExMUVBOTNCMDgzQUEyNjc3NDFDRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVFQzZDOUMwNDdGQTExRUE5M0IwODNBQTI2Nzc0MUNEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjVFQzZDOUMxNDdGQTExRUE5M0IwODNBQTI2Nzc0MUNEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YSZVdwAAAMRJREFUeNqMkEEOgkAMRWcaPIILrwdEMOrClQeBACPBPReTlScwMv5vGjMhE0OTT0v7H22wzrmHMWbnvb9DmVkR1toBSlFOgseozRRqV8CtwoxRsPUyz7PTYQlVf+CKHtZkyPICg6KEajWdkLoI3+mM/poMa1GIzTP0BUWkQK8PNvfsKdzRS4aRhCswOCBtMMygHPVTP5DrfFDPL5LlnTDQ/Aa0h65B/wYVS7/EfhaNUBO8NzE4ekEAHZG2uOKldTQ+AgwAa8ptyi8hUCQAAAAASUVORK5CYII="
          />
        </div>
      </div>
      <div class="epidemic-title">
        <span>视频信息</span>
      </div>
      <div class="video-box">
        <div
          class="video-template"
          @click="goDetail(data)"
          v-for="(data,i) in battleVideoDate"
          :key="i"
        >
          <img :src="data.photo | img" />
          <p>{{data.headline}}</p>
          <p style="display: flex; color: rgb(153, 153, 153);">
            <span></span>
            <span style="margin-left: auto;">{{data.createtime | times}}</span>
          </p>
        </div>
      </div>
      <div class="look-more" @click="lookMore('battleVideo')" v-show="tempBattleVideo.length>0">
        <span>更多信息</span>
        <img
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTQyIDc5LjE2MDkyNCwgMjAxNy8wNy8xMy0wMTowNjozOSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1RUM2QzlDMjQ3RkExMUVBOTNCMDgzQUEyNjc3NDFDRCIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1RUM2QzlDMzQ3RkExMUVBOTNCMDgzQUEyNjc3NDFDRCI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjVFQzZDOUMwNDdGQTExRUE5M0IwODNBQTI2Nzc0MUNEIiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjVFQzZDOUMxNDdGQTExRUE5M0IwODNBQTI2Nzc0MUNEIi8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+YSZVdwAAAMRJREFUeNqMkEEOgkAMRWcaPIILrwdEMOrClQeBACPBPReTlScwMv5vGjMhE0OTT0v7H22wzrmHMWbnvb9DmVkR1toBSlFOgseozRRqV8CtwoxRsPUyz7PTYQlVf+CKHtZkyPICg6KEajWdkLoI3+mM/poMa1GIzTP0BUWkQK8PNvfsKdzRS4aRhCswOCBtMMygHPVTP5DrfFDPL5LlnTDQ/Aa0h65B/wYVS7/EfhaNUBO8NzE4ekEAHZG2uOKldTQ+AgwAa8ptyi8hUCQAAAAASUVORK5CYII="
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      choose: ["疫情动态", "防控知识", "东坡战“疫”"],
      choosed: 0,
      nowTime: new Date().toLocaleDateString(),
      epideDate: [
        { people: "80820", title: "确诊人数", incr: 80 },
        { people: "80820", title: "疑似人数", incr: 80 },
        { people: "80820", title: "死亡人数", incr: 80 },
        { people: "80820", title: "治愈人数", incr: 80 }
      ],
      localDate: {
        confirmed: "",
        deadCount: "",
        curedCount: ""
      },
      dynamicDate: [],
      tempDynamic: [],
      preventionDate: [],
      tempPrevention: [],
      preventionVideoDate: [],
      tempPreventionVideo: [],
      battleDate: [],
      tempBattle: [],
      battleVideoDate: [],
      tempBattleVideo: []
    };
  },
  methods: {
    getEpidemicProvince() {
      this.axios
        .get(
          "http://api.tianapi.com/txapi/ncovcity/index?key=dc6fb7c2066419fdceeff0c4d98833a1"
        )
        .then(result => {
          let tempDate = result.data.newslist;
          tempDate.filter(item => {
            if (item.provinceName == "四川省") {
              this.localDate.confirmed = item.confirmedCount;
              this.localDate.deadCount = item.deadCount;
              this.localDate.curedCount = item.curedCount;
            }
          });
        });
    },
    getEpidemicAll() {
      this.axios
        .get(
          "http://api.tianapi.com/txapi/ncov/index?key=dc6fb7c2066419fdceeff0c4d98833a1"
        )
        .then(result => {
          let tempDate = result.data.newslist[0].desc;
          // console.log(tempDate);

          this.epideDate.forEach(item => {
            switch (item.title) {
              case "确诊人数":
                item.people = tempDate.confirmedCount;
                item.incr =
                  tempDate.confirmedIncr > 0
                    ? `+${tempDate.confirmedIncr}`
                    : `-${tempDate.confirmedIncr}`;
                break;
              case "疑似人数":
                item.people = tempDate.suspectedCount;
                item.incr =
                  tempDate.suspectedIncr > 0
                    ? `+${tempDate.suspectedIncr}`
                    : `-${tempDate.suspectedIncr}`;

                break;
              case "死亡人数":
                item.people = tempDate.deadCount;
                item.incr =
                  tempDate.deadIncr > 0
                    ? `+${tempDate.deadIncr}`
                    : `-${tempDate.deadIncr}`;

                break;
              case "治愈人数":
                item.people = tempDate.curedCount;
                item.incr =
                  tempDate.curedIncr > 0
                    ? `+${tempDate.curedIncr}`
                    : `-${tempDate.curedIncr}`;
                break;
              default:
                break;
            }
          });
        });
    },
    getServer() {
      this.axios(`/api/Main/VirusList?name=${this.choose[this.choosed]}`).then(
        result => {
          switch (this.choose[this.choosed]) {
            case "疫情动态":
              if (result.data.code == 0) {
                this.tempDynamic = result.data.msg;
                this.tempDynamic.forEach((item, i) => {
                  if (i > 2) return false;
                  this.dynamicDate.push(item);
                });
                this.tempDynamic.splice(0, 3);
              }
              break;
            case "防控知识":
              if (result.data.code == 0) {
                this.tempPrevention = result.data.msg;
                this.tempPrevention.forEach((item, i) => {
                  if (i > 2) return;
                  this.preventionDate.push(item);
                  this.tempPrevention.splice(0, 1);
                });
              }
              this.getVideo();
              break;
            case `东坡战“疫”`:
              // console.log(result.data.msg);
              if (result.data.code == 0) {
                this.tempBattle = result.data.msg;
                // console.log(this.tempBattle)
                for (let x = 0; x < 3; x++) {
                  if (this.tempBattle.length > 0) {
                    this.battleDate.push(this.tempBattle[0]);
                    this.tempBattle.splice(0, 1);
                  }
                }
              }
              this.getVideo();
              break;
            default:
              break;
          }
        }
      );
    },
    lookMore(value) {
      // console.log(this.tempPreventionVideo);
      switch (value) {
        case "dynamic":
          for (let x = 0; x < 3; x++) {
            if (this.tempDynamic.length > 0) {
              this.dynamicDate.push(this.tempDynamic[0]);
              this.tempDynamic.splice(0, 1);
            }
          }

          break;
        case "prevention":
          for (let x = 0; x < 3; x++) {
            if (this.tempPrevention.length > 0) {
              this.preventionDate.push(this.tempPrevention[0]);
              this.tempPrevention.splice(0, 1);
            }
          }

          break;
        case "preventionVideo":
          for (let x = 0; x < 4; x++) {
            if (this.tempPreventionVideo.length > 0) {
              this.preventionVideoDate.push(this.tempPreventionVideo[0]);
              this.tempPreventionVideo.splice(0, 1);
            }
          }
          break;
        case "battle":
          for (let x = 0; x < 3; x++) {
            if (this.tempBattle.length > 0) {
              this.battleDate.push(this.tempBattle[0]);
              this.tempBattle.splice(0, 1);
            }
          }
          break;
        case "battleVideo":
          for (let x = 0; x < 4; x++) {
            if (this.tempBattleVideo.length > 0) {
              this.battleVideoDate.push(this.tempBattleVideo[0]);
              this.tempBattleVideo.splice(0, 1);
            }
          }
          break;
        default:
          break;
      }
    },
    getVideo() {
      this.axios
        .get(`/api/Main/VirusVideoList?name=${this.choose[this.choosed]}`)
        .then(result => {
          // console.log(result.data.msg);
          switch (this.choose[this.choosed]) {
            case "防控知识":
              if (result.data.code == 0) {
                this.tempPreventionVideo = result.data.msg;
                for (let x = 0; x < 4; x++) {
                  if (this.tempPreventionVideo.length > 0) {
                    this.preventionVideoDate.push(this.tempPreventionVideo[0]);
                    this.tempPreventionVideo.splice(0, 1);
                  }
                }
              }
              break;
            case `东坡战“疫”`:
              if (result.data.code == 0) {
                this.tempBattleVideo = result.data.msg;
                for (let x = 0; x < 4; x++) {
                  if (this.tempBattleVideo.length > 0) {
                    this.battleVideoDate.push(this.tempBattleVideo[0]);
                    this.tempBattleVideo.splice(0, 1);
                  }
                }
              }
              break;
            default:
              break;
          }
        });
    },
    findImg(value) {
      if (value.indexOf("img") > -1) {
        return value.split('src="')[1].split('"')[0];
      } else {
        return false;
      }
    },
    chooseF(i) {
      if(i===this.choosed || i ==sessionStorage.getItem('dpidemic')) return
      this.choosed = i;
      sessionStorage.setItem("dpidemic", i);
      this.getServer();
    },
    goLetter() {
      this.$router.push({
        path: "/index/epidmic/letter",
        query: {
          title: "一封信"
        }
      });
    },
    goDetail(data) {
      // console.log(data);
      this.$router.push({
        path: "/publicDetail",
        query: { title: "新闻动态", id: data.id, dbnum: 1 }
      });
    },
    goVideo(data) {
      console.log(data);
    },
    gobaidu() {
      this.$router.push({
        path: "/iframevedio",
        query: {
          title: "疫情动态",
          iframeUrl:
            "https://voice.baidu.com/act/newpneumonia/newpneumonia/?from=osari_pc_1"
        }
      });
    }
  },
  mounted() {
    if (sessionStorage.getItem("dpidemic") != null) {
      this.choosed = sessionStorage.getItem("dpidemic");
    }
    this.getEpidemicAll();
    this.getEpidemicProvince();
    this.getServer();
  }
};
</script>
<style lang='scss' scoped>
.epidmic {
  .epidemic-battle,
  .epidemic-prevention {
    .video-box {
      .video-template {
        p {
          &:nth-child(2) {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-break: break-all;
          }
          &:nth-child(3) {
            font-size: 0.24rem;
          }
        }
        img {
          width: 100%;
          height: 2rem;
        }
        padding: 0.2rem;
      }
      display: grid;
      grid-template-columns: 50% 50%;
    }
    .text-box {
      .text-template {
        img {
          width: 2rem;
          height: 1.4rem;
          grid-column-start: 1;
          grid-column-end: 2;
          grid-row-start: 1;
          grid-row-end: 3;
        }
        p {
          &:nth-child(2) {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            word-break: break-all;
          }
          &:nth-child(3) {
            grid-row-start: 2;
            grid-row-end: 3;
          }
        }
        padding: 0.2rem;
        display: grid;
        grid-gap: 0.2rem;
        border-bottom: 0.01rem solid #eee;
      }
    }
    background: #fff;
    border-radius: 0.2rem;
    width: 90%;
    margin: 0.32rem auto 0 auto;
  }

  .epidemic-title {
    img {
      width: 0.13rem;
      margin: 0 0.1rem;
    }
    span {
      &:nth-child(1) {
        font-size: 0.36rem;
        margin-left: 0.2rem;
      }
      &:nth-child(2) {
        color: #999;
        font-size: 0.22rem;
        margin-left: 0.3rem;
      }
      &:nth-child(3) {
        color: #2d83fb;
        font-size: 0.26rem;
        margin-left: auto;
      }
    }
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    line-height: 2.5;
  }
  .look-more {
    img {
      margin-left: 0.1rem;
      width: 0.2rem;
      height: 0.1rem;
    }
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    color: #999;
    font-size: 0.28rem;
    padding: 0.4rem 0;
  }
  .epidemic-dynamic {
    .epidemic-realtime-dynamic {
      .realtime-dynamic-template {
        img {
          width: 3.24rem;
          height: 2rem;
          padding: 0 0.4rem;
        }
        p {
          &:nth-child(2) {
            margin-left: 0.4rem;
            font-size: 0.32rem;
            padding-top: 0.4rem;
            font-weight: 700;
          }
          &:nth-child(1) {
            span {
              margin-left: 0.2rem;
            }
            color: #999;
            font-size: 0.26rem;
            position: absolute;
            top: -0.14rem;
            left: 0.24rem;
          }
        }
        &::before {
          content: "";
          position: absolute;
          width: 0.08rem;
          height: 0.08rem;
          background: #10b77f;
          border-radius: 50%;
          left: -0.05rem;
          top: 0.03rem;
          z-index: 5;
        }

        width: 90%;
        margin: 0 auto;
        border-left: 0.02rem solid #b6dfd1;
        position: relative;
        padding-bottom: 0.4rem;
      }
      padding-bottom: 0.2rem;
    }
    .epidemic-local-sichuan {
      .sichuan-data {
        .sichuan-data-template {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          -ms-flex-pack: distribute;
          justify-content: space-around;
        }
        padding-bottom: 0.3rem;
      }
      .epidemic-title {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        line-height: 2.5;
      }
    }
    .epidemic-dynamic-nationwide-people {
      .nationwide-people-template {
        p {
          &:nth-child(1) {
            font-size: 0.38rem;
          }
          &:nth-child(2) {
            background: #f4f4f4;
          }
          &:nth-child(3) {
            span {
              &:nth-child(1) {
                color: #999;
              }
            }
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            -webkit-box-align: center;
            -ms-flex-align: center;
            align-items: center;
            font-size: 0.24rem;
          }
        }
        &:nth-child(1) {
          color: rgb(227, 57, 12);
        }
        &:nth-child(2) {
          color: rgb(238, 135, 11);
        }
        &:nth-child(3) {
          color: rgb(89, 89, 89);
        }
        &:nth-child(4) {
          color: rgb(12, 150, 104);
        }
        text-align: center;
        line-height: 2;
      }

      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-pack: distribute;
      justify-content: space-around;
    }

    background: #fff;
    border-radius: 0.2rem;
    width: 90%;
    margin: 0.32rem auto 0 auto;
  }
  .epidemic-choose {
    .choosed {
      background: -webkit-gradient(
        linear,
        left top,
        right top,
        from(#fa7a2e),
        to(#eb4900)
      ) !important;
      background: linear-gradient(90deg, #fa7a2e, #eb4900) !important;
      color: #fff !important;
    }
    span {
      background: #fff;
      border-radius: 0.32rem;
      padding: 0.2rem;
    }
    width: 90%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: distribute;
    justify-content: space-around;
    color: #999;
    margin: 0.54rem auto 0 auto;
  }
  .epidemic-proposal {
    p {
      &:nth-child(2) {
        color: #a94925;
        grid-column-start: 2;
        grid-column-end: 3;
        font-weight: 700;
        font-size: 0.32rem;
      }
      &:nth-child(3) {
        grid-column-start: 2;
        grid-column-end: 5;
        grid-row-start: 2;
        font-size: 0.26rem;
      }
      &:nth-child(4) {
        grid-column-start: 3;
        grid-column-end: 4;
        color: #999;
        text-align: center;
      }
    }
    img {
      &:nth-child(1) {
        width: 1rem;
        height: 1rem;
        margin: 0.2rem;
        grid-row-start: 1;
        grid-row-end: 3;
        grid-column-start: 1;
        grid-column-end: 2;
      }
      &:nth-child(5) {
        grid-column-start: 4;
        grid-column-end: 5;
        width: 0.15rem;
        height: 0.15rem;
      }
    }
    display: grid;
    grid-template-columns: 1.4rem 4rem;
    width: 90%;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 auto;
    background: #fff;
    border-radius: 0.34rem;
  }
  .epidmic-banner {
    img {
      width: 100%;
    }
  }
  padding: 1rem 0;
  background: #fedfc9;
  font-size: 0.3rem;
}
</style>